import { useThemeSetup } from '@whistler-ui/portal/hooks/useThemeSetup';

export const ThemeSetup = () => {
  useThemeSetup();

  return null;
};
